import { useQueryClient } from '@tanstack/react-query';

import { MORE_SETTINGS_QUERY_KEYS } from 'src/hooks/useGetMoreSettingsQuery';
import { HEADER_BANNERS_QUERY_KEYS } from 'src/hooks/useHeaderBannersQuery';
import { useRestMutation } from 'src/hooks/useRestMutation';

enum CampaignApiList {
  ParticipateCampaigns = '/api/v1/campaigns/participate',
}

export const useParticipateCampaignsMutation = () => {
  const queryClient = useQueryClient();
  return useRestMutation({
    path: CampaignApiList.ParticipateCampaigns,
    method: 'post',
    options: {
      onSuccess: () => {
        const CAMPAIGN_RELATED_QUERY_KEYS = [
          MORE_SETTINGS_QUERY_KEYS.moreSettings(),
          HEADER_BANNERS_QUERY_KEYS.getHeaderBanners(),
        ];
        CAMPAIGN_RELATED_QUERY_KEYS.forEach((queryKey) => {
          queryClient.invalidateQueries({ queryKey });
        });
      },
    },
  });
};
